module.exports = __webpack_public_path__ + "static/media/finger.f9cae37e.svg";